import * as React from 'react';
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {authorize, IWithRouterProps, withRouter} from "@athena-portal/components";
import {getProductByPolicyNumber, getSessionStorage} from "../../../../CommonFunctions";
import {CardForm} from "../../../../components/payments/CardForm";
import {
    FalconNavigatorHeader,
    FalconPaymentRequest,
    ICustomerPortalService,
    NewCardForm,
    Types
} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";

interface INewCardPaymentPageParams {
    policyNumber: string
    [key: string]: string | undefined
}

interface IState {
    settings: any,
    newCardForm?: NewCardForm
}

@authorize
export class NewCardPaymentPagePlain extends React.Component<IWithRouterProps<INewCardPaymentPageParams>, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps<INewCardPaymentPageParams>) {
        super(props);
        this.state = {
            settings: getSessionStorage("paymentSettings")
        };
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("New card payment");
        const policyNumber = this.props.params.policyNumber;

        const request: FalconPaymentRequest = new FalconPaymentRequest();
        request.invoiceType = this.state.settings.invoiceType;
        request.product = getProductByPolicyNumber(policyNumber);

        this.customerPortalService.newCardPaymentStart(request, policyNumber).subscribe((newCardForm: NewCardForm) => {
            this.setState({newCardForm})
        });
    }

    public render() {
        const returnUrl = this.state.settings?.returnUrl || "/dashboard";
        const description = this.state.settings?.description || "Payment";
        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="plugin">
                    <FalconNavigatorHeader back={returnUrl} title={description}/>
                    <CardForm newCardForm={this.state.newCardForm}
                              verifyNewCardFailed={this.props.location.state?.verifyCardFailed}
                              policyNumber={this.props.params.policyNumber}/>
                    {this.pluginTemplates.renderBackReloadLink("Back", false, returnUrl)}
                </div>
                <FalconFooter/>
            </React.Fragment>
        )
    }
}

export const NewCardPaymentPage = withRouter<{}, INewCardPaymentPageParams>(NewCardPaymentPagePlain)
